import { Divider } from '@mui/material'
import clsx from 'clsx'
import { Button, handleValid, Icon, Typography } from 'components'
import { SlideImageContent } from 'components/slideImageContent/SlideImageContent'
import { Icons, TabMyOrganizationItem, TypographyTypes } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { Path, useFieldArray, useForm } from 'react-hook-form'
import { PropsComponentsMyOrganization } from './interfaceSlide.type'

export const ComponentAssets: React.FC<PropsComponentsMyOrganization> = ({
	pos,
	name,
	setValue: setValueForm,
	setErrorForm,
	watch: watchParent,
	setFieldError
}): JSX.Element => {
	const data = watchParent(
		`${name}.${pos}.component_value` as Path<{ tabs: TabMyOrganizationItem[] }>
	) as { assets?: string[]; video: string }
	const [openSlide, setOpenSlide] = useState(false)
	const [slideImages, setSlideImages] = useState(false)
	const [nameSlide, setNameSlide] = useState('')

	const responseArray = data?.assets?.map(element => {
		return {
			title: element
		}
	})
	const { control, setValue, watch } = useForm({
		mode: 'onChange',
		defaultValues: {
			assets: responseArray ?? [],
			video: data.video
		}
	})

	const { fields, remove, append } = useFieldArray({
		control,
		name: 'assets'
	})

	const nameType = `assets-${name}-${pos}`

	useEffect(() => {
		const isValidForm = !watch().video.trim() && watch().assets.length === 0
		handleValid(nameType, !isValidForm, setFieldError)
		setErrorForm?.(isValidForm)
	}, [watch().assets, watch().video, nameType])

	useEffect(() => {
		const result = watch().assets.map(elemet => elemet.title)
		setValueForm(
			`${name}.${pos}.component_value.assets` as Path<{
				tabs: TabMyOrganizationItem[]
			}>,
			result
		)
		setValueForm(
			`${name}.${pos}.component_value.video` as Path<{
				tabs: TabMyOrganizationItem[]
			}>,
			watch().video
		)
	}, [watch().assets, watch().video])

	const amazonawsCount = fields.reduce((count, field) => {
		return field.title.includes('.amazonaws.com/') ? count + 1 : count
	}, 0)

	return (
		<div className="flex flex-col justify-between overflow-hidden p-2">
			<div className="flex flex-col w-full overflow-y-auto max-h-[calc(100vh-130px)] pb-6">
				<div className="flex flex-col md:flex-row justify-center items-center gap-8">
					<div className="flex items-center">
						<Icon
							src={Icons.burstMode}
							className="w-7 mr-2 text-blue-primary"
							fillPath
						/>
						<Typography
							title="Images:"
							className="text-gray-9"
							fontLeading="15/18"
							type={TypographyTypes.span}
						/>
						<p
							className={clsx(
								`text-[15px] text-gray-9 font-normal font-Inter border border-blue-primary rounded-full ml-2 px-2 ${
									fields && fields.length > 0
										? 'w-[24px] h-[24px] flex items-center justify-center'
										: 'max-w-max'
								}`
							)}
						>
							{amazonawsCount}
						</p>
					</div>
					<Divider
						className="block md:hidden"
						orientation="horizontal"
						flexItem
					/>
					<Divider
						className="hidden md:block"
						orientation="vertical"
						flexItem
					/>
					<div className="flex items-center">
						<Icon
							src={Icons.animatedImages}
							className="w-7 mr-2 text-blue-primary"
							fillPath
						/>
						<Typography
							title="Video:"
							className="text-gray-9"
							fontLeading="15/18"
							type={TypographyTypes.span}
						/>
						<p
							className={clsx(
								`text-[15px] text-gray-9 font-normal font-Inter border border-blue-primary rounded-full ml-2 px-2 ${
									fields && fields.length > 0
										? 'w-[24px] h-[24px] flex items-center justify-center'
										: 'max-w-max'
								}`
							)}
						>
							{watch().video ? 1 : 0}
						</p>
					</div>
				</div>
				<div className="w-full mt-6">
					<Button
						type="button"
						label={fields.length === 0 ? 'Add' : 'Edit'}
						onClick={() => {
							setSlideImages(true)
							setOpenSlide(true)
							setNameSlide('Upload an Image')
						}}
						className="!min-w-[130px]"
					/>
				</div>
			</div>
			{openSlide && (
				<SlideImageContent
					setOpenSlide={setOpenSlide}
					openSlide={openSlide}
					append={append}
					setSlideImages={setSlideImages}
					slideImages={slideImages}
					nameSlide={nameSlide}
					setNameSlide={setNameSlide}
					watch={watch}
					setValue={setValue}
					remove={remove}
				/>
			)}
		</div>
	)
}
